import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41486772"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "intro",
  class: "header loaded",
  "aria-label": "intro",
  "aria-describedby": "Introduction about Job Oaikhenah"
}
const _hoisted_2 = { class: "header__wrapper wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "header__svg",
  width: "100%",
  height: "100%"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    class: "shape1",
    width: "100%",
    height: "100%",
    "vector-effect": "non-scaling-stroke",
    "stroke-width": "0.1",
    "shape-rendering": "crispEdges"
  })
], -1))
const _hoisted_4 = { class: "header__content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "header__title" }, [
  /*#__PURE__*/_createTextVNode(" Hi, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" I'm Job Oaikhenah, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" a Software Engineer ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "header__subtitle" }, "Welcome to my portfolio", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "header__article",
  "aria-describedby": "professional statement"
}, " I'm a Fullstack Software Engineer passionate about building user-friendly, intuitive, and accessible applications—from powerful interfaces to efficient backend systems. I'm a logical, goal-driven, and diligent developer, committed to helping businesses grow and improving user satisfaction across the web. I solve problems through code and scalable software solutions, applying best practices, optimizing performance, and delivering clean, maintainable systems that look great and work even better. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_button = _resolveComponent("action-button")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createVNode(_component_action_button, {
          btnType: "button",
          header: true,
          "data-test": "header-button",
          onClick: _ctx.scrollToWork
        }, {
          default: _withCtx(() => [
            _createTextVNode("View my works")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}